module.exports = __webpack_public_path__ + "img/floorplan1.db464378.jpg";